<!-- Component to display a card with a label and an image -->
<template>
	<RadioGroupOption
		:value="props.funeralHome.id"
		v-slot="{ checked }"
	>
		<div
			class="group flex h-full min-h-42 cursor-pointer flex-col items-center rounded-lg bg-white px-2 py-5"
			:class="
				checked
					? 'border-accent-400 border-2 shadow-xl'
					: 'border-2 border-transparent shadow-sm'
			"
		>
			<div class="h-8">
				<img
					v-if="imageUrl"
					:src="imageUrl"
					:class="[
						'mr-auto ml-auto max-h-full max-w-20 object-contain',
						{ invisible: !imageUrl },
					]"
				/>
			</div>
			<!-- No pricebook warning icon and tooltip -->
			<div class="h-8">
				<div
					v-if="hasPricebookError"
					class="relative mt-3 flex max-h-full flex-col items-center"
				>
					<ExclamationTriangleIcon class="size-5 text-yellow-400" />
					<div
						class="absolute bottom-full mb-2 w-48 rounded-sm bg-yellow-50 p-2 text-center text-xs text-yellow-700 opacity-0 shadow-md transition-opacity duration-200 group-hover:opacity-100"
					>
						{{ t('newSession.errors.noPriceBook') }}
					</div>
				</div>
			</div>

			<div class="mt-1 w-full overflow-hidden text-center text-ellipsis">
				{{ name }}
			</div>
			<div
				class="overflow-wrap mt-auto w-full text-center text-xs text-ellipsis text-slate-500"
			>
				{{ priceBookSliced }}
			</div>
		</div>
	</RadioGroupOption>
</template>

<script setup lang="ts">
import { usePresentationLocale } from '@/i18n'
import type { CombinedFhLocation } from '@/types'
import { RadioGroupOption } from '@headlessui/vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'
import { computed } from 'vue'

const { t } = usePresentationLocale()

const props = defineProps<{
	funeralHome: CombinedFhLocation
	priceBookId?: string
	hasPricebookError?: boolean
}>()

const name = computed(() => props.funeralHome.name)
const priceBookSliced = computed(() => {
	return props.priceBookId ? props.priceBookId.slice(-6) : ''
})
const imageUrl = props.funeralHome.logo
</script>
